// Actions used for setting filters associated with given form fields

const OptionsFiltersActions = {
  SET_FILTER: 'OptionsFilters.SET_FILTER',
  CLEAR_FILTER: 'OptionsFilters.CLEAR_FILTER',
  CLEAR_FILTERS: 'OptionsFilters.CLEAR_FILTERS',
};

export default OptionsFiltersActions;
